import { BranchMenu } from '@lib/api';

import { Menu } from '../types';

export function fromMenuResponseToMenuDetails(
  response: BranchMenu,
  menuUUID: string,
): Menu {
  const categories = response.categories.map((cat) => {
    const items = cat.items.map((item) => {
      const sizes = item.sizes.map((size) => {
        return {
          price: size.price,
          name: {
            arName: size.arSizeName,
            enName: size.enSizeName,
          },
        };
      });
      return {
        itemUUID: item.itemUUID,
        name: {
          arName: item.arName,
          enName: item.enName,
        },
        availability: item.availability,
        sizes,
      };
    });
    return {
      items,
      availability: cat.availability,
      name: {
        arName: cat.arName,
        enName: cat.enName,
      },
      categoryUUID: cat.categoryUUID,
    };
  });

  return {
    uuid: menuUUID,
    availability: response.availability,
    categories,
  };
}
